import type { IconProps } from '../icon'
import type { NotificationIntent, NotificationStatusMapping } from './notification.types'

import { iconDictionary } from '../message/consts'

/** Maps each intent to the icon props auto-injected when no explicit icon is provided. */
export const INTENT_ICON_MAP: Record<NotificationIntent, IconProps> = {
  info: { name: iconDictionary.info },
  success: { name: iconDictionary.success },
  danger: { name: iconDictionary.error },
  warning: { name: iconDictionary.warning },
}

/** Icon props used when isLoading is true. */
export const LOADING_ICON_PROPS: IconProps = {
  name: 'uiSpinnerThird',
  pathFill: ['blue.40', 'blue.60'],
  variant: 'spinning',
}

export const notificationStatusMapping: NotificationStatusMapping = {
  error: { iconProps: { name: iconDictionary.error }, variant: 'inline', intent: 'danger' },
  info: { iconProps: { name: iconDictionary.info }, variant: 'inline', intent: 'info' },
  loading: { iconProps: LOADING_ICON_PROPS, variant: 'inline', intent: 'info', isLoading: true },
  success: { iconProps: { name: iconDictionary.success }, variant: 'inline', intent: 'success' },
  warning: { iconProps: { name: iconDictionary.warning }, variant: 'inline', intent: 'warning' },
  bannerError: { iconProps: { name: iconDictionary.error }, variant: 'banner', intent: 'danger' },
  bannerInfo: { iconProps: { name: iconDictionary.info }, variant: 'banner', intent: 'info' },
  bannerLoading: { iconProps: LOADING_ICON_PROPS, variant: 'banner', intent: 'info', isLoading: true },
  bannerSuccess: { iconProps: { name: iconDictionary.success }, variant: 'banner', intent: 'success' },
  bannerWarning: { iconProps: { name: iconDictionary.warning }, variant: 'banner', intent: 'warning' },
}
